import {
	FlatList,
	StyleSheet,
	Text,
	View,
	RefreshControl,
	TextInput,
	TouchableOpacity,
	Image,
} from 'react-native';
import React, { useEffect, useState } from 'react';
import Header from '../../Components/common/Header';
import { userStorage } from '../../utilities/Utility';
import ApiHandler from '../../API/ApiHandler';
import Loader from '../../Components/Loader';

import LeadsCard from '../../Components/LeadsCard';
import { FontAwesome } from '@expo/vector-icons';
import OpportunityCard from '../../Components/OpportunityCard';

const OportunityList = ({ navigation }) => {
	const [endReached, setEndReached] = useState(false);
	const [isRefreshing, setIsRefreshing] = useState(false);
	const [oportunityList, setOportunityList] = useState([]);
	const [offset, setOffset] = useState(0);
	const [emptyLead, setEmptyLead] = useState(false);
	const [loader, setLoader] = useState(true);
	const [totalList, setTotalList] = useState('');
	const [searchText, setSearchText] = useState('');

	useEffect(() => {
		setLoader(true);
		getOportunities(0, oportunityList, '');
	}, []);

	const getOportunities = async (offset, updatedList, searchText) => {
		let user = await userStorage();
		const response = await ApiHandler.getOportunity(user, offset, searchText);
		// console.log('from opportunity page', response.data);

		if (response.status == 200) {
			response.data.list &&
			response.data.list.length == 0 &&
			updatedList.length == 0
				? setEmptyLead(true)
				: setEmptyLead(false);
			setOportunityList([...updatedList, ...response.data.list]);
			setTotalList(response.data.total);
	
			setOffset(offset + 20);
		} else {
			console.log('error while fetching leads List');
		}

		// console.log(response.data.list);
		setIsRefreshing(false);
		setLoader(false);
	};
	const handleRefresh = async () => {
		getOportunities(0, [], '');
		setOffset(0);
	};
	const loadMoreData = async () => {
		console.log('loadmore... calling');
		if (!endReached && oportunityList.length % 20 == 0) {
			setEndReached(true);
			console.log('load more Leads list', oportunityList.length);
			getOportunities(offset, oportunityList, '');
		}
	};


	return (
		<View style={{ flex: 1, backgroundColor: 'white', paddingTop: 30 }}>
			<TouchableOpacity
				style={{
					width: 60,
					height: 60,
					borderRadius: 33,
					backgroundColor: '#0D4C92',
					position: 'absolute',
					bottom: 50,
					right: 25,
					elevation: 4,
					zIndex: 4,
					alignItems: 'center',
					justifyContent: 'center',
				}}
				onPress={() => navigation.navigate('Device Activation')}
			>
				<FontAwesome name="plus" color={'white'} size={22} />
			</TouchableOpacity>
			<Header />
			<>
				{loader ? (
					<Loader />
				) : (
					<>
						<View
							style={{
								flexDirection: 'row',
								alignItems: 'center',
								paddingHorizontal: 10,
								marginVertical: 6,
							}}
						>
							<TextInput
								placeholder="Please Search Here"
								// keyboardType="phone-pad"
								style={{
									flex: 1,
									alignItems: 'center',
									borderWidth: 1,
									borderColor: 'rgba(0,0,0,0.4)',
									borderRadius: 6,
									paddingLeft: 8,
									paddingVertical: 6,
								}}
								value={searchText}
								onChangeText={(e) => {
									setSearchText(e);
								}}
							/>
							<TouchableOpacity
								style={{
									...styles.button,
									backgroundColor: '#26b2d1',
								}}
								onPress={() => getOportunities(0, [], searchText)}
							>
								<Text style={{ color: 'white' }}>Search</Text>
							</TouchableOpacity>
						</View>
						<Text
							style={{
								fontWeight: '600',
								fontSize: 16,
								paddingHorizontal: 10,
								paddingVertical: 6,
							}}
						>
							{oportunityList.length == 0
								? 'Total Opportunites (0)'
								: 'Total Opportunities (' +
								  oportunityList.length +
								  ' of ' +
								  totalList +
								  ')'}
						</Text>
						{/* <ApiError
							responseCode={responseCode}
							setResponseCode={setResponseCode}
						/> */}
						{emptyLead ? (
							<FlatList
								data={['demo']}
								keyExtractor={(i, j) => j}
								showsVerticalScrollIndicator={false}
								renderItem={({ item }) => {
									return (
										<View
											style={{ alignItems: 'center', justifyContent: 'center' }}
										>
											<Image
												style={{ height: 360, width: 300, marginTop: 80 }}
												source={require('../../assets/images/No_Leads.png')}
											/>
											<Text
												style={{
													fontWeight: '600',
													fontSize: 16,
												}}
											>
												No Leads Found
											</Text>
										</View>
									);
								}}
								refreshControl={
									<RefreshControl
										refreshing={isRefreshing}
										onRefresh={() => {
											handleRefresh();
										}}
									/>
								}

								// ListFooterComponent={renderFooter}
							/>
						) : (
							<FlatList
								data={oportunityList}
								keyExtractor={(i, j) => j}
								showsVerticalScrollIndicator={false}
								renderItem={({ item }) => {
									return <OpportunityCard item={item} navigation={navigation} />;
								}}
								refreshControl={
									<RefreshControl
										refreshing={isRefreshing}
										onRefresh={() => {
											handleRefresh();
										}}
									/>
								}
								onEndReached={loadMoreData}
								onMomentumScrollBegin={() => {
									setEndReached(false);
								}}
								onEndReachedThreshold={0.3}
								// ListFooterComponent={renderFooter}
							/>
						)}
					</>
				)}
			</>
		</View>
	);
};

export default OportunityList;

const styles = StyleSheet.create({
	button: {
		paddingVertical: 10,
		marginLeft: 3,
		paddingHorizontal: 15,
		borderRadius: 4,
		alignSelf: 'flex-end',
	},
});
